export default __webpack_public_path__ + "static/media/Resources.fcb54a0b.svg";